"use client";

import { CaseData } from "@/cms/models";
import CaseSlider from "./CaseSlider";
import { SwiperSlide } from "swiper/react";
import PropertyEditorialCard from "./PropertyEditorialCard";
import PropertyRowCard from "./PropertyRowCard";

const FocusEstateComponentCaseCardClient: React.FC<{
  config: {
    cardStyle?: "editorial";
    overskrift: string;
    placering: string;
    type: "classic" | "casecard";
    cases: CaseData[];
    cmsData: any;
  };
}> = ({ config }) => {
  const { cases: casesData, cmsData } = config;

  if (!casesData || casesData.length === 0) {
    return null;
  }
  if (!cmsData?.applicationId) {
    return null;
  }

  const filteredCases = casesData.filter((x) => x !== null);

  return (
    <div className="w-full relative">
      <CaseSlider>
        {filteredCases.map((x, index) => (
          <SwiperSlide className="relative" key={`${x.id}-${index}`}>
            {config.cardStyle === "editorial" ? (
              <PropertyEditorialCard property={x} layout="horizontal" />
            ) : (
              <PropertyRowCard property={x} shadow="none" className="w-full" />
            )}
          </SwiperSlide>
        ))}
      </CaseSlider>
    </div>
  );
};

export default FocusEstateComponentCaseCardClient;
